<template>
  <div class="modal show_modal" tabindex="-1" role="dialog">
     <div class="modal-dialog modal-lg-custom modal-dialog-centered">
      <div class="modal-content"> 
        <div class="modal-header">
            <div class="container">
                  <button  type="button" style="position: absolute;"   @click="closeDriver()"  class="btn btn-small text-white"  >
                    <v-icon class="text-white">mdi-arrow-left</v-icon> {{ $t("Back") }}
                  </button> 
                  <div class="text-center"><h4>{{ $t("Assign Driver ") }}</h4></div> 
             </div>
        </div>  
        <div class="modal-body p-4" style="height: auto">
          <loading v-if="loading"/>
          <div class="container">
              <div class="row">
                <div class="col-4">
                  <h4 class="mt-4 mb-3">  {{ $t('Select driver')}} </h4>
                  <div class="list-group">
                  
                      <a href="#" class="list-group-item list-group-item-action" :class="{active: selected.id == driver.id}"
                       v-for="(driver, index) of drivers" :key="index" @click="selected=driver">
                        <div class="d-flex w-100 justify-content-between">
                          <h5 class="mb-1">{{ driver.name }}</h5> 
                          <small>{{ driver.gender }}</small>
                        </div>
                        <p class="mb-1">{{ driver.email}}</p> 
                      </a> 
                    </div>
                </div>
                <div class="col-8 ">  
                  <div class="text-center" v-if="!selected.id" >
                      <img src="@/assets/images/driver.svg" width="100px" alt="">
                      <h4 class="mt-4">  {{ $t('Select driver to assign delivery! ')}} </h4>
                  </div>
                  <div class=" p-4" >  
                    <div v-if="selected.id">
                    <p class="lead"> {{ $t('Driver')}}  : <strong> {{ selected.name }}</strong></p> 
                    <p> {{ $t('Email')}}: {{ selected.email }}</p>
                    <p> {{ $t('Gender')}}: {{ selected.gender }}</p>
                    <hr class="my-4">
                    <p class="lead mt-2">
                       <a class="btn btn-primary btn-lg" href="#" @click="assignDriver()" role="button">
                         <loading v-if="loading_assign_driver"/>
                         
                         {{ $t('Assign') }}</a>
                    </p>
                    </div>
                  </div>

                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue'
import store from "@/store";
export default {
  name: "BaseDriver",
  props: {
    invoice: {
      type: Object,
      default: {},
    },
  },
  data: () => ({ 
    selected: {}, 
  }),
  computed: {
    restaurant() {
      return store.getters["restaurant/restaurant"];
    },
    drivers() {
      return store.getters["driver/drivers"];
    },
    loading() {
      return store.getters["driver/loading_get_driver"];
    },
    loading_assign_driver() {
      return store.getters["driver/loading_assign_driver"];
    },
  },
  methods: {
    async closeDriver() {
      return this.$emit("input", false );
    },
    async getDrivers() {
      await store.dispatch('driver/getDrivers', { restaurant_id: this.restaurant.id });
    },
    async assignDriver() {
      await store.dispatch('driver/assignDriver', { sale_id: this.invoice.id, driver_id: this.selected.id });
      Vue.notify({
                group: 'notification', 
                type: 'success', 
                speed: 100,
                duration: 5000, 
                text: 'Send to driver ' + this.selected.name,
      }); 
      return this.$emit("input", false );
    },
  }, 
  mounted(){
    this.getDrivers(); 
  }
};
</script>